export default "__VITE_ASSET__1ef8787e__"